var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassengers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4649 10.3438C12.7483 9.62747 11.7766 9.22466 10.7641 9.22466H4.65242C3.63909 9.22466 2.66825 9.62747 1.95159 10.3438C1.23575 11.061 0.833252 12.0334 0.833252 13.0467V14.5754C0.833252 14.9973 1.17492 15.3401 1.59742 15.3401H13.8199C14.2416 15.3401 14.5841 14.9982 14.5841 14.5754V13.0467C14.5833 12.0334 14.1808 11.061 13.4649 10.3438Z",
    fill: "#58B9E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70825 7.69518C9.81752 7.69518 11.5274 5.98399 11.5274 3.87313C11.5274 1.76227 9.81752 0.0510864 7.70825 0.0510864C5.59898 0.0510864 3.88909 1.76227 3.88909 3.87313C3.88909 5.98399 5.59898 7.69518 7.70825 7.69518Z",
    fill: "#58B9E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5716 9.98607C17.9141 9.32807 17.0233 8.95863 16.0941 8.95863H12.9499C13.3474 9.17212 13.7258 9.42565 14.0541 9.75423C14.9333 10.6332 15.4174 11.8016 15.4174 13.0459V14.5687H18.8974C19.2841 14.5687 19.5983 14.2551 19.5983 13.8673V12.4646C19.5974 11.5356 19.2283 10.6441 18.5716 9.98607Z",
    fill: "#58B9E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2474 6.88874C11.8233 7.30488 12.5258 7.55674 13.2908 7.55674C15.2258 7.55674 16.7941 5.98639 16.7941 4.04993C16.7941 2.11347 15.2258 0.543124 13.2908 0.543124C12.6049 0.543124 11.9691 0.748278 11.4291 1.08937C12.0116 1.86662 12.3608 2.82901 12.3608 3.87313C12.3608 5.02317 11.9399 6.07562 11.2474 6.88874Z",
    fill: "#58B9E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassengers);
export default __webpack_public_path__ + "static/media/Passengers.ccb31ebbef1d2ab5092c8823a6d2a40a.svg";
export { ForwardRef as ReactComponent };